import React, { lazy } from 'react';
import { Routes, Route } from 'react-router-dom';

const Deposit = lazy(() => import('../../pages/Deposit/DepositPage'));

function PagesRoute() {
  return (
    <Routes>
      <Route path="/*" element={<Deposit />} />
    </Routes>
  );
}

export default PagesRoute;
